<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page

========================================================================================== -->


<template>
  <div id="knowledge-base-page">
    <!-- JUMBOTRON -->
    <div class="knowledge-base-jumbotron">
      <div :style="{'background-image': 'url('+cdn_url+background_image+')'}" style="background-position: center"
           class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white">Select your Active Course on IP Learn</h1>
        <p class="text-white">You may purchase access to a course by contacting Intellectual Point staff. If you have not recieved access to a course you purchased, contact our support team.</p>
        <!---  <vs-input icon-no-border placeholder="Search for Course" v-model="course_selector_query" icon-pack="feather" icon="icon-search" size="large" class="w-full mt-6 transparent" /> //!TODO FIX SEARCH --->
      </div>
    </div>
    <!-- KNOWLEDGE BASE CARDS  -->
    <div>
      <slide-x-left-transition group class="vx-row match-height" tag="div">
        <div v-for="item in courses_total" :key="item.id" class="vx-col w-1/2 lg:w-1/3 mb-base">
          <course-selector-card :item="item"/>
        </div>
      </slide-x-left-transition>
    </div>
    <div v-if="!courses_loaded && !courses_none && courses_total.length === 0" class="simple-spinner">
      <span></span>
    </div>
    <h1 v-if="courses_none">You Have No Courses On Your Account</h1>
  </div>
</template>

<!--suppress ES6ShorthandObjectProperty -->
<script>
import CourseSelectorCard from '@/views/course/course-selector/components/CourseSelectorCard'

export default {
  data () {
    return {
      course_selector_query: '',
      courses_total: [],
      courses_loaded: false,
      courses_none: false,
      cdn_url: 'https://cdn.discordapp.com/attachments',
      background_image: '/746242308084858900/859503094102753280/img21-scaled.png'

    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {
    get_course_list () {
      this.$http.get('users/@me/subscriptions')
        .then(subscriptions => {


          if (subscriptions.data.data.length === 0) {
            this.courses_none = true
            // location.replace('https://www.youtube.com/watch?v=jE2VvGZktJo')
          }

          subscriptions.data.data.forEach(x => {
            this.$http.get(`courses/${x.course_id}`)
              .then(async response => {
                if (response.status === 200 && response.data.data.status === 'active') {
                  if (!this.activeCourseInfo.selected) {
                    this.courses_total.push(response.data.data)
                  }
                  if (this.activeCourseInfo.selected && this.activeCourseInfo.id !== response.data.data.id) {
                    this.courses_total.push(response.data.data)
                  }
                }
              })
          })

          if (this.activeCourseInfo && this.activeCourseInfo.selected !== false) {
            this.courses_total.push(this.activeCourseInfo)
          }

          this.courses_loaded = true

        })
    }
  },
  beforeDestroy () {
    this.courses_total = null
  },
  beforeMount () {
    this.get_course_list()
  },
  components: {
    CourseSelectorCard
  }
}
</script>

